import { BrandLogo } from "@/components/BrandLogo";

const fmtDate = (iso) => {
  try { return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" }); }
  catch { return iso; }
};
const fmtDateTime = (iso) => {
  try { return new Date(iso).toLocaleString(undefined, { year: "numeric", month: "long", day: "numeric", hour: "2-digit", minute: "2-digit" }); }
  catch { return iso; }
};

// Printable whole-record score & grade report. `.cert-print-area` is the only
// element kept visible by the @media print rules in index.css.
export function ScoreReport({ records, user }) {
  const items = records || [];
  const best = items.length ? Math.max(...items.map((i) => Math.round(i.score))) : null;
  const avg = items.length ? Math.round(items.reduce((s, i) => s + i.score, 0) / items.length) : null;

  return (
    <div className="cert-print-area bg-white border border-slate-200 rounded-lg p-8" data-testid="score-report">
      <div className="flex items-start justify-between gap-4 border-b border-slate-200 pb-5">
        <div className="flex flex-col gap-2">
          <BrandLogo chip />
          <div className="text-[10px] uppercase tracking-[0.25em] text-slate-500">Training record</div>
        </div>
        <div className="text-right text-xs text-slate-500">
          <div className="font-semibold text-slate-800 text-sm">{user?.name || user?.email || "Trainee"}</div>
          {user?.email && <div>{user.email}</div>}
          <div className="mt-1">Generated {fmtDateTime(new Date().toISOString())}</div>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4 mt-5">
        <div><div className="text-3xl font-bold text-slate-900">{items.length}</div><div className="text-[10px] uppercase tracking-wider text-slate-400">Sessions</div></div>
        <div><div className="text-3xl font-bold text-emerald-600">{best ?? "—"}</div><div className="text-[10px] uppercase tracking-wider text-slate-400">Best score</div></div>
        <div><div className="text-3xl font-bold text-slate-900">{avg ?? "—"}</div><div className="text-[10px] uppercase tracking-wider text-slate-400">Average</div></div>
      </div>

      <table className="w-full mt-6 text-sm border-collapse" data-testid="score-report-table">
        <thead>
          <tr className="text-left text-[10px] uppercase tracking-wider text-slate-400 border-b border-slate-200">
            <th className="py-2">Simulator</th>
            <th className="py-2">Date</th>
            <th className="py-2 text-right">Score</th>
            <th className="py-2 text-right">Grade</th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 ? (
            <tr><td colSpan={4} className="py-6 text-center text-slate-400">No saved sessions yet.</td></tr>
          ) : items.map((it) => (
            <tr key={it.id} className="border-b border-slate-100">
              <td className="py-2 font-medium text-slate-800">{it.simulator_name}</td>
              <td className="py-2 text-slate-500">{fmtDate(it.created_at)}</td>
              <td className="py-2 text-right font-semibold text-slate-900">{Math.round(it.score)}</td>
              <td className="py-2 text-right font-semibold text-emerald-600">{it.grade}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="mt-6 pt-4 border-t border-slate-200 text-[11px] text-slate-400">
        CertIVSims · simulator practice scores &amp; grades. This is a record of practice attempts, not a formal statement of competency.
      </div>
    </div>
  );
}

export default ScoreReport;
